import { useEffect, useState } from 'react';
import { getControlSocialActivityGroup } from '../../API/apiService';

function SocialControlMeetings({
  activityId,
  groupId,
  initialActivity,
  initialGroup,
  renderContent
}) {
  const [activity, setActivity] = useState(initialActivity || null);
  const [group, setGroup] = useState(initialGroup || null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let mounted = true;

    async function loadContext() {
      const result = await getControlSocialActivityGroup(
        Number(activityId),
        Number(groupId)
      );

      if (!mounted) return;

      if (result?.activity && result?.group) {
        setActivity(result.activity);
        setGroup(result.group);
        setNotFound(false);
      } else {
        setNotFound(true);
      }
      setLoading(false);
    }

    if (activityId && groupId) {
      loadContext();
    } else {
      setLoading(false);
      setNotFound(true);
    }

    return () => {
      mounted = false;
    };
  }, [activityId, groupId]);

  if (loading && !activity && !group) {
    return (
      <section className='meetings'>
        <p className='meetings__empty'>Cargando encuentros...</p>
      </section>
    );
  }

  if (notFound || !activity || !group) {
    return (
      <section className='meetings'>
        <p className='meetings__empty'>
          No fue posible encontrar el grupo de Control Social.
        </p>
      </section>
    );
  }

  if (typeof renderContent === 'function') {
    return renderContent({activity, group});
  }

  return (
    <section className='meetings'>
      <div className='meetings__main group'>
        <div className='group__info info'>
          <div className='info__icon icon'>
            <span
              className='material-symbols-rounded icon__img'
              aria-hidden='true'
            >
              groups
            </span>
          </div>
          <span className='info__title'>{group.code}</span>
          <span className='info__value'>Lista de Encuentros</span>
        </div>
      </div>

      <div className='meetings__details'>
        <p className='meetings__empty'>Aún no hay encuentros registrados.</p>
      </div>

      <div className='meetings__actions'>
        <button
          type='button'
          className='meetings__action meetings__action--add'
          disabled
          title='Pendiente de conectar con Control Social'
        >
          <span className='material-symbols-rounded' aria-hidden='true'>
            add
          </span>
          <span className='meetings__action-text'>Agregar sesión</span>
        </button>
      </div>
    </section>
  );
}

export default SocialControlMeetings;
